import _ from 'lodash'

import Options from './product/options'
import Buy from './product/buy'

const Product = {
  showTitle: (title) => {
    return title
  },
  showTotal: (state, view) => {
    const total =
      parseInt(state.product.selected_variant.price) * parseInt(state.product.selected_quantity)

    return view.currency.showPrice(state, view, {
      price: total,
    })
  },
  isAvailable: (variant) => {
    return !!variant.available
  },
  showPrice: (s, v, p) => {
    return v.currency.showPrice(s, v, {
      price: p.price,
      original: p.compare_at_price,
    })
  },
  showNote: (p) => {
    let message = false

    // Check if p is a variant (has inventory_quantity directly) or a product (has variants array)
    let is_low = false
    
    if (p.variants && Array.isArray(p.variants)) {
      // It's a product object - check all variants (for product listings)
      is_low = !!_.find(p.variants, (v) => {
        return (
          v.inventory_management == 'shopify' &&
          v.inventory_policy == 'deny' &&
          v.inventory_quantity != null &&
          v.inventory_quantity < 3 &&
          v.inventory_quantity > 0
        )
      })
    } else if (p.inventory_quantity != null) {
      // It's a variant object - check just this variant (for product page)
      is_low = (
        p.inventory_management == 'shopify' &&
        p.inventory_policy == 'deny' &&
        p.inventory_quantity < 3 &&
        p.inventory_quantity > 0
      )
    }

    // For product objects, check product-level properties
    if (p.compare_at_price && p.compare_at_price > p.price) message = 'On Sale'
    if (p.available === false) message = 'Sold Out'
    if (is_low) message = 'Low in Stock'

    return message ? message : ''
  },
  hasSalePrice: (state, view, variant) => {
    const price = variant.price
    const original = variant.compare_at_price
    return original != null && original > price
  },
  showNotify: (data, state) => {
    const product = data.product
    const variant = state.product.selected_variant
    const available = variant.available
    const is_notifiable = _.includes(product.tags, 'notifiable')

    return is_notifiable && !available ? true : false
  },
  isNotified: (state) => {
    const get = []
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (a, name, value) {
      get[name] = value
    })

    return !!get['contact_posted']
  },

  showGalleryCaption: (d, s) => {
    const offset_top = s.window.scroll.top.current
    const window_height = s.window.resize.height.current

    const images = _.clone(s.product.images).reverse()

    const image = _.find(images, (v) => {
      const window_half = offset_top + window_height / 2
      // var image_half  = v.top + (v.height/2);
      return window_half > v.top
    })

    if (!image) return ''

    const title = image.caption
    const total = d.product.images.length

    return `${image.index} / ${total} ${title}`
  },
  showContentClass: (s) => {
    const content_bottom = s.product.content_bottom
    const window_bottom = s.window.scroll.top.current + s.window.resize.height.current
    const sticky_end = window_bottom > content_bottom

    return {
      'sticky-end': sticky_end,
    }
  },
  showSelectionGroup: (s, optionType) => {
    return s.product.selection_group === optionType
  },
  getBuyAvailability: (d, s) => {
    return s.product.selected_variant.available
  },
  formatGallery: (images) => {
    return images.filter((image) => image.alt.indexOf('ways-to-wear') === -1)
  },
  formatSlideshow(s, images, opts_switch = '') {
    return _.chain(images)
      .map((img, idx) => {
        return {
          alt: img.alt,
          url: img.src,
          width: img.width,
          height: img.height,
          class: s.product.selected_slide == idx ? 'active' : '',
        }
      })
      .value()
  },
  formatW2wImageSrc(w2w) {
    let ret
    if (w2w.images && w2w.images.length < 1) return ''
    ret = w2w.images[0].src
    if (w2w.active == true && w2w.images[1]) ret = w2w.images[1].src
    return ret
  },
  scrollToImage(state, optionValue) {
    const colour = optionValue.split(' ')[0].toLowerCase()
    const gallery = document.querySelector('[data-ref="gallery"]')
    const firstImage = gallery.querySelector(`[data-hook*="${colour}"]`)

    if (firstImage && window.matchMedia('(min-width: 680px)').matches) {
      // firstImage.scrollIntoView({ behavior: "smooth" });
      TweenLite.to(window, 0.6, { scrollTo: { y: firstImage, offsetY: 40 } })
    }
  },
  scrollToW2W() {
    TweenLite.to(window, 0.8, { scrollTo: { y: '[data-ref="ways-to-wear"]', offsetY: 100 } })
  },
}

export default _.merge(Product, Buy, Options)
